import $ from "jquery";
import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RPM } from "../names.js";
const crossRpmMove = ()=>{
    var _window_rml;
    return CrossSellingPointer.isActionAvailable(RPM, "move") && ((_window_rml = window.rml) == null ? void 0 : _window_rml.hooks.register("attachment/move/finished", (ids, to)=>{
        new CrossSellingPointer($(`.rml-container:visible li[data-li-id="${to}"]`), RPM, "move");
    }));
};
export { crossRpmMove };
